// src/components/store/sections/testimonials/TestimonialV58PodiumstarsOceanCyan.tsx
"use client";

import React from "react";
import DynamicTestimonialVariant from "./DynamicTestimonialVariant";

export default function TestimonialV58PodiumstarsOceanCyan(props: any) {
  return (
    <DynamicTestimonialVariant
      variantNumber={58}
      archKey="podium_stars"
      archLabel="5-Star Podium Showcase"
      palName="OceanCyan"
      grad="from-cyan-500 via-sky-500 to-blue-700"
      lightBg="bg-cyan-50"
      textCol="text-cyan-700"
      borderCol="border-cyan-200"
      btnCls="bg-blue-600 hover:bg-blue-700"
      hexCol="#06b6d4"
      {...props}
    />
  );
}
